import { AUTO_GROUPS } from "discourse/lib/constants";

let _autoGroupFlair, _noAutoFlair;

// All automatic groups except "everyone" (which doesn't have flair)
const FLAIR_GROUP_NAMES = Object.values(AUTO_GROUPS)
  .filter((g) => g.id !== AUTO_GROUPS.everyone.id)
  .map((g) => g.name);

export default function autoGroupFlairForUser(site, user) {
  if (!_autoGroupFlair) {
    initializeAutoGroupFlair(site);
  }

  if (_noAutoFlair) {
    // No automatic groups have flair.
    return null;
  }

  if (user.admin && _autoGroupFlair.admins) {
    return _autoGroupFlair.admins;
  }

  if (user.moderator && _autoGroupFlair.moderators) {
    return _autoGroupFlair.moderators;
  }

  if (_autoGroupFlair.staff && (user.admin || user.moderator)) {
    return _autoGroupFlair.staff;
  }

  let trustLevel = user.trust_level || user.trustLevel;

  if (trustLevel) {
    for (let i = trustLevel; i >= 0; i--) {
      if (_autoGroupFlair[`trust_level_${i}`]) {
        return _autoGroupFlair[`trust_level_${i}`];
      }
    }
  }
}

export function resetFlair() {
  _autoGroupFlair = null;
  _noAutoFlair = null;
}

function initializeAutoGroupFlair(site) {
  _autoGroupFlair = {};
  _noAutoFlair = true;

  FLAIR_GROUP_NAMES.forEach((groupName) => {
    const group = site.groups?.find((item) => item.name === groupName);
    if (group && group.flair_url) {
      _noAutoFlair = false;
      _autoGroupFlair[groupName] = {
        flair_name: group.name.replace(/_/g, " "),
        flair_url: group.flair_url,
        flair_bg_color: group.flair_bg_color,
        flair_color: group.flair_color,
      };
    }
  });
}
